import { IsInt } from 'class-validator';

import { Announcement } from '../announcement';

export class AnnouncementDeleteRequest implements Pick<Announcement, 'id'> {
    @IsInt()
    public readonly id: number;

    constructor(data?: Partial<AnnouncementDeleteRequest>) {
        this.id = data?.id;
    }
}
